module.exports = __webpack_public_path__ + "static/media/amca_logo_2016_1745498110357.66298eca.png";